<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <DateModal
        modalID="beyond_economical_repair"
        :fetchData="fetchData"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"
      ></DateModal>
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Beyond Economic Repair"
            :dateFrom="
              from(dateFrom)
                ? $formatUSDate(from(dateFrom))
                : $formatUSDate(dateFrom)
            "
            :dateTo="
              to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
            "
          ></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDateIcon="true"
            :showDownloadPdfIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-date="modalDateEvent"
            @emit-pdf-download="downloadPDF"
          ></HeaderControl>
        </div>
        <div class="chart-wrapper" style="margin-top: 30px">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <FooterOptions
          v-if="locParam == 1"
          :showTop10="true"
          :showOverall="false"
          :showAll="true"
          @top-10-all-data-emit="top10AllDataEmit"
        ></FooterOptions>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import Datepicker from "vuejs-datepicker";
import DateModal from "../shared/DateModal.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import FooterOptions from "../shared/FooterOptions.vue";
import { BeyondEconomicalRepairCityDashboardChart } from "../../utils/ChartProps";
import { from, isUserLoggedIn, to } from "../../utils/Utils";

export default {
  name: "BeyondEconomicalRepairCityDashboard",
  components: {
    router,
    highcharts: Chart,
    Datepicker,
    DateModal,
    HeaderTitle,
    HeaderControl,
    LoadingCard,
    FooterOptions
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      from: from,
      to: to,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      dateTo: "",
      city: "",
      locationName: "",
      productGroup: "",
      productModel: "",
      locationsIds: "",
      chartOptions: {}
    };
  },
  watch: {
    dateFrom() {
      this.chartOptions = BeyondEconomicalRepairCityDashboardChart(
        router,
        this.locParam,
        this.from(this.dateFrom),
        this.to(this.dateTo),
        this.city,
        this.locationsIds,
        this.locationName
      );
    },
    dateTo() {
      this.chartOptions = BeyondEconomicalRepairCityDashboardChart(
        router,
        this.locParam,
        this.from(this.dateFrom),
        this.to(this.dateTo),
        this.city,
        this.locationsIds,
        this.locationName
      );
    }
  },

  methods: {
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },
    modalDateEvent() {
      this.exitFullscreen();
      this.$bvModal.show("beyond_economical_repair");
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: "BER",
        client: this.idCity
      };
      this.$http.get("api/charts/chart_city.php", { params }).then(
        res => {
          this.chartOptions.title.text = "Total units: " + res.data.totals;

          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.ProductGroupTotal) > parseFloat(b.ProductGroupTotal)
                ? -1
                : 1
            );

            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });

            let newArr = tmp.slice(0, 10);

            this.chartOptions.series[0].data = newArr;
            this.chartOptions.drilldown.series = smp;
          } else {
            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.ProductGroupTotal) > parseFloat(b.ProductGroupTotal)
                ? -1
                : 1
            );

            this.chartOptions.series[0].data = tmp;
            this.chartOptions.drilldown.series = smp;
          }

          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Beyond Economic Repair | " +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          " - " +
          (this.to(this.dateTo) ? this.to(this.dateTo) : this.dateTo) +
          " " +
          this.locationName;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Beyond Economic Repair | " + this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom + " - " + this.to(this.dateTo)
            ? this.to(this.dateTo)
            : this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "BER-" +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          "-" +
          (this.to(this.dateTo) ? this.to(this.dateTo) : this.dateTo)
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
      this.city = this.nameCity + "%287%29";
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.chartOptions = BeyondEconomicalRepairCityDashboardChart(
      router,
      this.locParam,
      this.from(this.dateFrom),
      this.to(this.dateTo),
      this.city,
      this.locationsIds,
      this.locationName
    );
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
